const createProgram = ({
  name,
  type,
  sourceUrl,
  mapEmbedUrl,
  summary,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
  address,
}) => ({
  name,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions', admissions],
  ],
  paragraphs: [
    focus,
    'Program details, costs, schedules, credentials, and campus availability can change. Review the official school website before applying.',
  ],
  highlights,
  address,
  mapListingUrl: mapEmbedUrl,
  mapEmbedUrl,
});

export const programs = [
  createProgram({
    name: 'Monroe Community College',
    type: 'Public community college certificate',
    sourceUrl: 'https://www.monroecc.edu/depts/hvac/',
    mapEmbedUrl: 'https://maps.google.com/?cid=17390578461338571564&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Monroe Community College offers a targeted Heating, Ventilating, and Air Conditioning certificate designed for completion in about 30 weeks.',
    credential: 'HVAC certificate',
    format: 'Hands-on shop training with technical instruction',
    length: 'Approximately 30 weeks',
    tuition: 'Approximately $6,590',
    admissions: 'Review current MCC admissions and HVAC certificate requirements',
    focus: 'This public education pathway emphasizes practical shop training and prepares students for immediate mechanical entry-level careers. Students should ask about current shop hours, equipment access, payment options, and certification preparation.',
    highlights: [
      'Approximately 30-week certificate',
      'Hands-on mechanical shop training',
      'Public college pathway with approximately $6,590 tuition',
    ],
    address: 'Monroe Community College, Rochester, NY',
  }),
  createProgram({
    name: 'Apex Technical School',
    type: 'Private technical school',
    sourceUrl: 'https://apexschool.com/campus/',
    mapEmbedUrl: 'https://maps.google.com/?cid=3141425496933151089&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Apex Technical School in Long Island City provides a 900-hour Heating, Air Conditioning, Ventilation and Refrigeration Maintenance Technology program.',
    credential: 'Professional career training certificate',
    format: 'Intensive classroom and practical tool training',
    length: 'Approximately 8 months and 900 hours',
    tuition: 'Approximately $18,379 including tuition and fees',
    admissions: 'Contact Apex for current enrollment requirements',
    focus: 'Apex focuses heavily on direct tool experience, system troubleshooting, and practical maintenance skills. Prospective students should confirm the current equipment, class schedule, supply costs, and career-support services.',
    highlights: [
      '900-hour HVACR maintenance technology program',
      'Approximately eight-month completion timeline',
      'Intensive practical tool and troubleshooting experience',
    ],
    address: 'Apex Technical School, Long Island City, NY',
  }),
  createProgram({
    name: 'Suffolk County Community College',
    type: 'Public community college',
    sourceUrl: 'https://www.sunysuffolk.edu/about-suffolk/campus-information/index.jsp',
    mapEmbedUrl: 'https://maps.google.com/?cid=13907010104646145553&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Suffolk County Community College provides public academic programs with structured courses that combine classroom instruction and technical laboratory work.',
    credential: 'Certificate or Associate degree pathway',
    format: 'Classroom instruction with technical labs',
    length: 'Varies by certificate or degree track',
    tuition: 'Approximately $6,050 per year for in-state tuition',
    admissions: 'Review current SUNY Suffolk admissions and program requirements',
    focus: 'Students can explore flexible certificate or Associate degree options while building a foundation in environmental controls and mechanics. Verify the current HVAC-related course sequence, laboratory access, residency rates, and financial-aid options.',
    highlights: [
      'Public college tuition pathway',
      'Certificate and Associate degree options',
      'Classroom and technical laboratory instruction',
    ],
    address: 'Suffolk County Community College, Suffolk County, NY',
  }),
  createProgram({
    name: 'Erie Community College',
    type: 'Public community college',
    sourceUrl: 'https://catalog.ecc.edu/content.php?catoid=26&navoid=1385&print',
    mapEmbedUrl: 'https://maps.google.com/?cid=13822743999719024225&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Erie Community College offers affordable public pathways in mechanical technologies through certificate and Associate degree study.',
    credential: 'Mechanical technology certificate or Associate degree',
    format: 'Engineering theory, technical courses, and hands-on labs',
    length: 'Varies by credential and course sequence',
    tuition: 'Public community college tuition; verify current rates',
    admissions: 'Review current ECC catalog and admissions information',
    focus: 'The curriculum balances core engineering theory with laboratory work to prepare graduates for local technical service roles. Students should confirm which current mechanical technology courses align with HVAC careers and what equipment is available.',
    highlights: [
      'Certificate and Associate degree pathways',
      'Affordable public college education',
      'Combination of engineering theory and practical labs',
    ],
    address: 'Erie Community College, Buffalo, NY',
  }),
  createProgram({
    name: 'Hudson Valley Community College',
    type: 'Public community college',
    sourceUrl: 'https://map.hvcc.edu/',
    mapEmbedUrl: 'https://maps.google.com/?cid=10623296821305273454&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Hudson Valley Community College delivers accredited technical programs shaped around regional workforce needs and public community college tuition rates.',
    credential: 'Stackable certificate or Associate in Applied Science degree',
    format: 'Technical coursework with campus diagnostic laboratories',
    length: 'Varies by certificate or A.A.S. pathway',
    tuition: 'Public community college tuition; verify current rates',
    admissions: 'Review current HVCC admissions and program requirements',
    focus: 'Students gain essential diagnostic skills through campus labs and can build credentials progressively. Confirm the current HVAC-related offerings, lab equipment, course sequence, transfer options, and financial-aid support.',
    highlights: [
      'Regional workforce-focused technical programs',
      'Stackable certificate credentials',
      'Associate in Applied Science pathway',
    ],
    address: 'Hudson Valley Community College, Troy, NY',
  }),
  createProgram({
    name: 'Mohawk Valley Community College',
    type: 'Public community college',
    sourceUrl: 'https://mvcc.edu/about/maps-directions.php',
    mapEmbedUrl: 'https://maps.google.com/?cid=9199315858300670905&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Mohawk Valley Community College features supportive trade and technology pathways with public tuition rates and financial-aid availability.',
    credential: 'Technical certificate or degree pathway',
    format: 'Classroom lectures with practical workshop training',
    length: 'Varies by program and credential',
    tuition: 'Standard public college tuition; verify current rates',
    admissions: 'Review current MVCC admissions and program offerings',
    focus: 'MVCC combines technical lectures with workshop experience to build reliable skills for aspiring technicians. Prospective students should ask about HVAC-related coursework, hands-on practice, student support, financial aid, and local employer connections.',
    highlights: [
      'Supportive trade and technology environment',
      'Workshop-based practical training',
      'Public tuition rates and financial-aid availability',
    ],
    address: 'Mohawk Valley Community College, Utica, NY',
  }),
  createProgram({
    name: 'The Refrigeration Institute',
    type: 'Private refrigeration and HVAC training school',
    sourceUrl: 'https://www.therefrigerationinstitute.com/about-us/',
    mapEmbedUrl: 'https://maps.google.com/?cid=11806173165021717034&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'The Refrigeration Institute offers a specialized hybrid Refrigeration and Air Conditioning course with flexible morning and evening schedules.',
    credential: 'Refrigeration and air conditioning training',
    format: 'Hybrid instruction with hands-on technical training',
    length: 'Approximately 7 months and 450 hours',
    tuition: '$12,000 plus supplies',
    admissions: 'Contact the institute for current enrollment requirements',
    focus: 'The program is designed around practical refrigeration and air-conditioning skills while supporting preparation for certifications such as EPA Section 608. Confirm the current hybrid schedule, supply costs, lab requirements, and testing support.',
    highlights: [
      '450-hour specialized HVACR course',
      'Approximately seven-month completion timeline',
      'Morning and evening schedule options',
      'EPA Section 608 preparation',
    ],
    address: 'The Refrigeration Institute, New York, NY',
  }),
  createProgram({
    name: 'Dutchess Community College',
    type: 'Public community college',
    sourceUrl: 'https://www.sunysuffolk.edu/about-suffolk/campus-information/index.jsp',
    mapEmbedUrl: 'https://maps.google.com/?cid=16348006945198230915&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Dutchess Community College provides accessible public college education with targeted technical training options and strong student support services.',
    credential: 'Technical certificate or degree pathway',
    format: 'Structured academic courses with laboratory learning',
    length: 'Varies by technical pathway',
    tuition: 'Budget-friendly public tuition; verify current rates',
    admissions: 'Review current DCC admissions and program offerings',
    focus: 'Students build foundational technical expertise through academic and lab courses designed to support entry into the regional technical job market. Verify current HVAC-related programs, lab schedules, credential options, and career services.',
    highlights: [
      'Accessible public community college education',
      'Technical training and laboratory coursework',
      'Student support services and regional career preparation',
    ],
    address: 'Dutchess Community College, Poughkeepsie, NY',
  }),
  createProgram({
    name: 'Electrical Training Center',
    type: 'Private vocational trade school',
    sourceUrl: 'https://www.electricaltrainingcenter.edu/about-us',
    mapEmbedUrl: 'https://maps.google.com/?cid=18065084894021248241&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ&output=embed',
    summary: 'Electrical Training Center delivers focused vocational instruction for electrical, HVAC, and mechanical systems in a practical workshop environment.',
    credential: 'Trade training and entry-level certification preparation',
    format: 'Hands-on vocational workshop instruction',
    length: 'Verify current HVAC and mechanical course schedules',
    tuition: 'Request current tuition, fees, and supply costs',
    admissions: 'Contact the school for current admissions requirements',
    focus: 'The curriculum emphasizes direct skill acquisition and practical workshop experience to help students pursue entry-level certifications quickly. Ask about HVAC course availability, equipment, class times, certifications, and job-placement resources.',
    highlights: [
      'Electrical, HVAC, and mechanical systems focus',
      'Direct practical skill acquisition',
      'Workshop-based entry-level certification preparation',
    ],
    address: 'Electrical Training Center, New York, NY',
  }),
  createProgram({
    name: 'Isaac Heating and Air Conditioning Training Center',
    type: 'Contractor-backed professional training center',
    sourceUrl: 'https://www.isaacheating.com/community-involvement/',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2988092.7470156862!2d-80.0557632482212!3d42.998085384776715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d9f328190d9c99%3A0xa4cd8b88fb8e405f!2sIsaac%20Heating%20%26%20Air%20Conditioning!5e0!3m2!1sen!2sus!4v1790284828010!5m2!1sen!2sus',
    summary: 'Isaac Heating and Air Conditioning Training Center offers contractor-backed professional training for residential and commercial climate-control systems.',
    credential: 'Professional HVAC training and certification preparation',
    format: 'Industry-focused technical instruction',
    length: 'Verify current training schedules and course length',
    tuition: 'Request current tuition and supply information',
    admissions: 'Contact the training center for enrollment details',
    focus: 'Participants build real-world proficiency in climate-control systems with training shaped by an active HVAC contractor. Confirm the current curriculum, hands-on equipment, residential and commercial coverage, certification preparation, and employment pathways.',
    highlights: [
      'Contractor-backed professional education',
      'Residential and commercial climate-control training',
      'Direct preparation for industry certifications',
    ],
    address: 'Isaac Heating and Air Conditioning Training Center, Rochester, NY',
  }),
  createProgram({
    name: 'LaGuardia Community College',
    type: 'Public continuing education program',
    sourceUrl: 'https://www.laguardia.edu/ce/career-skills-training/hvacr-1-training-program/',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.8282492055505!2d-73.93506359999999!3d40.743804600000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25ed4bb39e7d9%3A0x5c0884acbe9b2064!2sLaGuardia%20Community%20College!5e0!3m2!1sen!2sus!4v1790285354059!5m2!1sen!2sus',
    summary: 'LaGuardia Community College offers a short-term, in-person HVACR 1 Training Program spanning approximately three months and preparing adult learners for residential and commercial climate-control work.',
    credential: 'Institutional certificate with eligibility to sit for the Refrigeration Machine Operator License',
    format: 'In-person career skills training',
    length: 'Approximately 3 months',
    tuition: 'Approximately $2,600',
    admissions: 'Adults age 18 and older with a high school diploma or equivalency',
    focus: 'The curriculum prepares students to install and repair residential and commercial climate-control systems. Confirm current class dates, total fees, practical lab hours, and the latest Refrigeration Machine Operator License eligibility requirements directly with LaGuardia Community College.',
    highlights: [
      'Short-term, approximately three-month program',
      'In-person HVACR training',
      'Institutional certificate',
      'Eligibility to sit for the Refrigeration Machine Operator License',
    ],
    address: 'LaGuardia Community College, Long Island City, NY',
  }),
  createProgram({
    name: 'SUNY Jefferson',
    type: 'Public online workforce training program',
    sourceUrl: 'https://sunyjefferson.edu/academics/programs/hvac-technician.php',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2870.410897701776!2d-75.93726592380524!3d43.9922309710879!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d8702e420fbced%3A0xce9efc8378bdd384!2sJefferson%20Community%20College!5e0!3m2!1sen!2sus!4v1790285403131!5m2!1sen!2sus',
    summary: 'SUNY Jefferson offers a flexible, 100% online HVAC/R Technician training program totaling 330 course hours over approximately 12 months.',
    credential: 'HVAC/R Technician training with preparation for industry certifications such as EPA Section 608',
    format: 'Self-paced online instruction',
    length: 'Approximately 12 months and 330 course hours',
    tuition: 'Approximately $4,999, including materials and tool vouchers',
    admissions: 'Review current SUNY Jefferson enrollment requirements',
    focus: 'The self-paced curriculum covers commercial and residential equipment fundamentals, end-to-end system operation, troubleshooting, and service best practices. Students should confirm how practical skills are supported, current certification exam arrangements, and the latest materials and tool voucher terms.',
    highlights: [
      '100% online program',
      '330 course hours over approximately 12 months',
      'Commercial and residential equipment fundamentals',
      'Materials and tool vouchers included',
      'EPA Section 608 preparation',
    ],
    address: 'SUNY Jefferson, Watertown, NY',
  }),
  createProgram({
    name: 'SUNY Westchester Community College',
    type: 'Public online workforce training program',
    sourceUrl: 'https://www.sunywcc.edu/academics/majors-programs/heating-ventilation-and-air-conditioning-hvac/',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.138130146164!2d-73.7891834!3d41.065973199999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f2aff10ab169%3A0x106cb292384220d8!2sSUNY%20Westchester%20Community%20College!5e0!3m2!1sen!2sus!4v1790285443052!5m2!1sen!2sus',
    summary: 'SUNY Westchester Community College features an online 12-month, 330-hour Certified HVAC/R Technician training option for adult learners seeking flexible career preparation.',
    credential: 'Certified HVAC/R Technician training with EPA Section 608 Universal, NATE Ready to Work, and HVAC Excellence preparation',
    format: 'Self-paced online instruction',
    length: 'Approximately 12 months and 330 course hours',
    tuition: 'Approximately $4,985, including a 66-piece tool kit and exam voucher packages',
    admissions: 'Review current SUNY Westchester Community College enrollment requirements',
    focus: 'The program combines flexible online study with preparation for several industry credentials. Prospective students should verify the current tool kit contents, exam voucher coverage, payment options, practical training expectations, and certification timelines.',
    highlights: [
      'Online 12-month training option',
      '330 course hours',
      '66-piece tool kit included',
      'Exam voucher packages included',
      'EPA Section 608 Universal, NATE Ready to Work, and HVAC Excellence preparation',
    ],
    address: 'SUNY Westchester Community College, Valhalla, NY',
  }),
  createProgram({
    name: 'The Turner School',
    type: 'Private vocational trade school',
    sourceUrl: 'https://www.turnerschool.com/',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d386895.6763632987!2d-74.60133401093745!3d40.748332000000026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259af063e7bd3%3A0x71def97b994f6ba1!2sThe%20Turner%20School!5e0!3m2!1sen!2sus!4v1790285489392!5m2!1sen!2sus',
    summary: 'The Turner School provides a comprehensive HVAC and refrigeration program combining written theory with practical training over approximately six months.',
    credential: 'HVAC and refrigeration vocational training',
    format: 'Combined classroom theory and hands-on practical instruction',
    length: 'Approximately 6 months',
    tuition: '$5,700 paid in full or $6,150 through the structured payment plan',
    admissions: 'Contact The Turner School for current enrollment requirements',
    focus: 'Tuition includes essential books and supplies, and qualified students may use VA education benefits. Confirm current class schedules, practical lab hours, payment-plan terms, VA benefit eligibility, and the latest program outcomes before enrolling.',
    highlights: [
      'Comprehensive HVAC and refrigeration program',
      'Six-month written theory and practical course track',
      'Books and supplies included',
      'Full-payment and structured-payment options',
      'VA education benefits accepted for qualified students',
    ],
    address: 'The Turner School, New Jersey',
  }),
];

export const resources = [
  {
    title: 'Air-Conditioning, Heating, and Refrigeration Institute',
    description: 'Explore industry standards, equipment efficiency information, and HVAC career resources.',
    url: 'https://www.ahrinet.org/',
  },
  {
    title: 'EPA Section 608 Technician Certification',
    description: 'Review federal refrigerant handling requirements and approved certification programs.',
    url: 'https://www.epa.gov/section608',
  },
  {
    title: 'New York Department of State',
    description: 'Review New York licensing and regulatory information relevant to skilled trades.',
    url: 'https://dos.ny.gov/',
  },
  {
    title: 'U.S. Bureau of Labor Statistics',
    description: 'Research HVAC mechanic and installer duties, pay, education, and employment outlook.',
    url: 'https://www.bls.gov/ooh/installation-maintenance-and-repair/heating-air-conditioning-and-refrigeration-mechanics-and-installers.htm',
  },
];